import { useEffect, useState } from 'react';

export const useMediaQuery = (queryString: string) => {
  const [queryMatches, setQueryMatches] = useState(
    window.matchMedia(queryString).matches,
  );

  useEffect(() => {
    const query = window.matchMedia(queryString);

    if (query.matches !== queryMatches) {
      setQueryMatches(query.matches);
    }

    const listener = () => setQueryMatches(query.matches);
    query.addEventListener('change', listener);

    return () => query.removeEventListener('change', listener);
  }, [queryMatches, queryString]);

  return queryMatches;
};
